import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// 1. استيراد مكونات الموقع الرئيسي
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Team from "./components/Team";
import CTA from "./components/CTA";
import Library from "./components/Library";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import ArticleDetails from "./components/ArticleDetails"; // 🆕 استيراد صفحة تفاصيل المقال

// 2. استيراد لوحة التحكم
import AdminPanel from "./AdminPanel";

// 3. مكون فرعي: يجمع كل أقسام الصفحة الرئيسية
// يستقبل اللغة كـ Props بدلاً من تعريفها بداخله
const MainSite = ({ lang, setLang }) => {
  return (
    <div className="App font-sans">
      <Navbar lang={lang} setLang={setLang} />
      <Hero lang={lang} />
      <About lang={lang} />
      <Services lang={lang} />
      <Team lang={lang} />
      <CTA lang={lang} />
      <Library lang={lang} />
      <Booking lang={lang} />
      <Contact lang={lang} />
    </div>
  );
};

// 4. المكون الرئيسي
function App() {
  // ⚠️ نقلنا حالة اللغة هنا عشان نمررها لكل الصفحات
  const [lang, setLang] = useState("en");

  return (
    <Router>
      <Routes>
        {/* المسار الأول: الصفحة الرئيسية للموقع */}
        <Route path="/" element={<MainSite lang={lang} setLang={setLang} />} />

        {/* 🆕 المسار الجديد: صفحة عرض المقال بالتفصيل */}
        <Route path="/article/:id" element={<ArticleDetails lang={lang} />} />

        {/* مسار لوحة التحكم */}
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
